export interface Util_IISODateString {
    dateType: 'IISODateString'
    value: string
}

export interface Util_IUnixTime {
    dateType: 'IUnixTime'
    value: number
}

export function Util_isoDateString(value: string): Util_IISODateString {
    return { dateType: 'IISODateString', value }
}

export function Util_unixTime(value: number): Util_IUnixTime {
    return { dateType: 'IUnixTime', value }
}

function dayOf(date: Date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export function Util_isSameDay(dateA: Date, dateB: Date) {
    return dayOf(dateA).getTime() === dayOf(dateB).getTime()
}

// for handling undefineds
export function Util_toDate(date: string) {
    return date ? new Date(date) : undefined
}

export function Util_isoDateNow() {
    return Util_isoDateString(new Date().toISOString())
}
